import { render, staticRenderFns } from "./FriendApply.vue?vue&type=template&id=50e0a076&scoped=true"
import script from "./FriendApply.vue?vue&type=script&lang=js"
export * from "./FriendApply.vue?vue&type=script&lang=js"
import style0 from "./FriendApply.vue?vue&type=style&index=0&id=50e0a076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_13f162de80bf2e87404863986ae68eb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0a076",
  null
  
)

export default component.exports